<template>
  <div v-if="bodyShow" class="infor-main">
    <div v-for="(item,index) in list" :key="index">
      <!-- title  标题 -->
      <div class="title" v-if="item.type=='title'">
        <h3>{{item.label}}</h3>
      </div>
      <!-- text -->
      <div class="text" v-if="item.type=='text'">
        <label>{{item.label}}</label>
        <input type="text" v-model="item.val" @input="inputChange()" :placeholder="item.config.placeholder" />
      </div>
      <!-- select -->
      <div class="select" v-if="item.type=='select'">
        <label>{{item.label}}</label>
        <span :class="['input',item.val?'color3':'']" @click="cityPoup(index,item)">{{item.val?item.val:item.config.placeholder}}</span>
        <span class="bottom">
          <img @click="cityPoup(index,item)" src="@a/action-bottom.png" />
        </span>
      </div>
      <!-- radio -->
      <div class="radio" :style="{marginBottom:item.config.condition=='rectangle'?'15px':'0'}" v-if="item.type=='radio'">
        <!-- 性别 -->
        <div class="rectangle" v-if="item.config.condition=='rectangle'">
          <label class="label-title">{{item.label}}</label>
          <div class="man">
            <img src="@a/xb1.png" alt />
            <label :class="{on:item.val=='男'}" for="man">
              <input id="man" type="radio" @change="inputChange()" value="男" v-model="item.val" /> {{item.config.content[0]}}
            </label>
          </div>
          <div class="woman">
            <img src="@a/xb2.png" alt />
            <label :class="{on:item.val=='女'}" for="woman">
              <input id="woman" type="radio" @change="inputChange()" value="女" v-model="item.val" /> {{item.config.content[1]}}
            </label>
          </div>
        </div>
        <!-- 其它 -->
        <div v-else class="default">
          <div class="radio-identity">
            <label class="label-title">{{item.label}}</label>
            <div v-for="(itm,idx) in item.config.content" :key="idx" class="identity">
              <label :class="['icon',itm==item.val?'on':'']" :for="itm">
                <input :id="itm" type="radio" @change="identityChange(item.val,identityObj[item.val])" :value="itm" v-model="item.val" />
              </label>
              <label :for="itm">{{itm}}</label>
            </div>
          </div>
          <!-- 当前选择是职场人还是学生根据选择的切换模块 -->
          <div v-if="item.val" class="tab-identity">
            <!-- -->
            <div v-for="(tItem,tIndex) in identityObj[item.val]" :key="tIndex" class="Working-people">
              <!-- text -->
              <div class="text" v-if="tItem.type=='text'">
                <label>{{tItem.label}}</label>
                <input type="text" v-model="tItem.val" @input="inputChange()" :placeholder="tItem.config.placeholder" />
              </div>
              <!-- select -->
              <div class="select" v-if="tItem.type=='select'">
                <label>{{tItem.label}}</label>
                <span :class="['input',tItem.val?'color3':'']" @click="selectPoup(tItem.label,tItem.config.api,tIndex)">{{tItem.val?tItem.val:tItem.config.placeholder}}</span>
                <span class="bottom">
                  <img src="@a/action-bottom.png" />
                </span>
              </div>
              <!-- 年级其他 -->
              <div class="text" v-if="tItem.type=='select' && otherGrade(tItem)">
                <label></label>
                <input type="text" v-model="tItem.other" @input="inputChange()" :placeholder="otherGradeVal.placeholder" />
              </div>
              <!-- textarea -->
              <div class="textarea" v-if="tItem.type=='textarea'">
                <label class="label-title">{{tItem.label}}</label>
                <textarea :placeholder="tItem.config.placeholder" @input="inputChange()" v-model="tItem.val"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- checkbox -->
      <div class="checkbox" v-if="item.type=='checkbox'">
        <div v-if="item.config.condition=='one'" class="familiarity">
          <label class="label-title">{{item.label}}</label>
          <div v-for="(cItem,cIndex) in item.config.content" :key="cIndex" class="checkbox-group">
            <label :class="['icon',item.val&&item.val.includes(cItem)?'on':'']" :for="cItem">
              <input :id="cItem" type="checkbox" @change="checkboxChange()" :value="cItem" v-model="item.val" />
            </label>
            <label class="checkbox-text" :for="cItem">{{cItem}}</label>
            <!-- 如果选择其它则显示文本框  -->
            <input class="other" v-if="isOther(cItem,item,item.val)" @input="inputChange()" v-model="item.other" type="text">
          </div>
        </div>
        <!-- 标签 -->
        <div v-if="item.config.condition=='two_line'" class="tag">
          <label class="label-title">{{item.label}}</label>
          <div class="tag-box">
            <div v-for="(cItem,cIndex) in item.config.content" :key="cIndex" class="checkbox-group">
              <label @click="styleStags(!item.val.includes(cItem) &&item.val.length>=5)" :class="['icon',item.val && item.val.includes(cItem)?'on':'',!item.val.includes(cItem) &&item.val.length>=5?'style_tags_active':'']" :for="cItem">
                <input :id="cItem" :disabled="!item.val.includes(cItem) &&item.val.length>=5" type="checkbox" @change="checkboxChange()" :value="cItem" v-model="item.val" />
              </label>
              <label @click="styleStags(!item.val.includes(cItem) &&item.val.length>=5)" :class="['checkbox-text',!item.val.includes(cItem) &&item.val.length>=5?'style_tags_active':'']" :for="cItem">{{cItem}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 提交按钮 -->
    <a :class="['submit-btn',saveBtn?'on':'']" @click="doSaveHandle()">提交</a>
    <!-- 省市弹出层 -->
    <van-popup v-model="citysShow" position="bottom" @close="pickerShowClick(false)">
      <van-area ref="areas" :area-list="areaList" :columns-num="2" :value="cityVal" @cancel="citysShow=false" @confirm="cityCfm" />
    </van-popup>
    <!-- 下拉窗口 -->
    <van-popup class="popup" v-model="pickerShow" position="bottom" @close="pickerShowClick(false)">
      <van-picker  show-toolbar :columns="columns" :default-index="0"   @cancel="pickerShow=false" @confirm="pickerCfm" />
    </van-popup>
    <!-- 确认提交弹窗 -->
    <van-popup class="pub_alert" v-model="confirmShow">
      <div class="confirm_box">
        <h2>个人信息确认提交后不能更改</h2>
        <div class="btn_group">
          <a class="confirm on" href="javascript:;" @click="savehandle()">确认提交</a>
          <a class="cancel" href="javascript:;" @click="confirmShow=false">我再检查一下</a>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import areaList from "@/utils/area";
import {
  getIProfession,
  getIJob,
  getIFunctions,
  geIUser,
  setIUser
} from "@/api/course";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        bodyShow: false,
        list: [],
        cid: "",
        areaList, //省市数组
        gender: null, //性别
        identity: "", //身份
        checkArr: [], //熟悉度数组
        identityObj: {}, //身份信息对象
        selectList: {}, //下拉窗口数据对象
        citysShow: false, //省市窗口
        cityVal: '', //城市选择的值
        pickerShow: false, //显示下拉窗口
        pickerArray: {}, //下拉对象
        api: '', //所点击的下拉框
        listIdx: null, //list数组下标
        identityIdx: null, //身份数组下标
        identityVal: '', //保存当前身份信息
        otherGradeVal: '', //年级其他值
        saveBtn: false, //提交按钮
        userdetail: [], //用户提交的数据
        confirmShow: false //确认提交弹窗
      }
    },
    computed: {
      // 下拉弹出层显示窗
      columns() {
        return this.api ? this.pickerArray[this.api].name : [];
      },
      /*
       *@return:str
       *@Description: Json字符串转对象
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-06 11:59:24
       */
      stringParseify() {
        return str => {
          return JSON.parse(str ? str : '{}');
        };
      }
    },
    methods: {
      preventDefault: function(e) {
        e.preventDefault();
      },
      /*
       *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-28 12:18:35
      */
      pickerShowClick(newval) {
        let self = this;
        if (newval) {
          document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //阻止默认事件
        } else {

          document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //打开默认事件
        }
      },
      // 风格标签
      styleStags(bool) {
        if (bool) {
          this.$toast('最多选择5个哦！');
        }
      },
      inputChange() {
        this.$forceUpdate();
        this.validationHandle();
      },
      /*
       *实时渲染复选框
       */
      checkboxChange(val) {
        this.$forceUpdate();
        this.validationHandle();
      },
      /*
       *@Description: 年级选择其他
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-08 15:56:06
       */
      otherGrade(item) {
        if (item.config.selected && item.config.selected[item.val]) {
          this.otherGradeVal = item.config.selected[item.val];
          return true;
        }
        // this.otherGradeVal['val'] = '';
        return false;
      },
      /*
       *@param: val 当前身份
       *@return:
       *@Description: 身份切换时触发
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-08 15:25:33
       */
      identityChange(val, list) {
        this.$forceUpdate();
        this.identityVal = val;
        this.validationHandle();
        this.initData(list);
      },
      // 因为动态添加的属性不能双向绑定数据，有可能不能输入，所以给定默认值
      initData(val) {
        val.forEach((item, index) => {
          if (!item.val) {
            item.val = '';
          }
          if (!item.other) {
            item.other = '';
          }
        });

      },
      /*
       *@param: index 下标,item 对象
       *@Description: 取得当前点击的下标
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-08 11:42:41
       */
      cityPoup(index, item) {
        this.listIdx = index;
        this.citysShow = true;
        this.pickerShowClick(true);
      },
      // 确认选择城市触发
      cityCfm(picker) {
        let idx = this.listIdx;
        this.$set(this.list[idx], 'val', picker[0].name + ' ' + picker[1].name);
        this.validationHandle();
        this.citysShow = false;
      },
      /*
       *@Description: 下拉选择的值
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-07 18:51:09
       */
      pickerCfm(picker) {
        let sf = this.identityVal,
          idx = this.identityIdx;
        if (sf && idx >= 0) {
          // 当前身份的下标下的值
          this.identityObj[sf][idx]['val'] = picker;
        } else {
          this.$toast("身份等信息不能为空！");
        }
        this.validationHandle();
        this.pickerShow = false;
      },
      /*
       *@param: label 名称,api 当作key值,idx 下标
       *@Description: 处理下拉框显示值
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-07 18:35:14
       */
      selectPoup(label, api, idx) {
        this.identityIdx = idx;
        // 获得点击的下拉框属性
        this.api = api ? api : label;
        let id = [],
          name = [];
        this.selectList[this.api].forEach((item, index) => {
          if (typeof item == 'object') {
            this.$set(id, index, item.id);
            this.$set(name, index, item.name);
          } else {
            this.$set(id, index, item);
            this.$set(name, index, item);
          }

        });
        this.pickerArray[this.api] = {
          id,
          name
        };

        this.pickerShow = true;
        this.pickerShowClick(true);
      },
      /*
       *@param: checkItem,item list的对象且类型为checkbox
       *@return: bool
       *@Description: 判断是否选择其他
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-07 12:30:20
       */
      isOther(checkItem, item, val) {
        let config = item.config;
        let other = config.selected;
        let bool = false;
        // 获得对象的所有key值
        Object.keys(other).forEach((item2, index) => {
          bool = (val.includes(checkItem) && checkItem == item2 ? true : false) || bool;
        });
        return bool;
      },
      /*
       *@Description: 提交判断
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-12 10:05:55
       */
      doSaveHandle() {
        if (this.saveBtn) {
          this.confirmShow = true;
        } else {
          this.$toast('信息不能为空！');
        }
      },
      /*
       *@Description: 提交数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-08 18:57:28
       */
      savehandle() {
        let arr = [];
        let o = '';
        // 循环组装数据格式
        this.list.forEach((item, index) => {
          if (item.type != 'title') {
            if (item.type == 'radio') {
              let identityArr = [];
              // 判断是否是身份模块
              if (item.config.condition != 'rectangle') {
                item.config.content_config[item['val']].forEach((rItem, rIndex) => {
                  let bool = rItem.config.selected && rItem.config.selected[rItem.val];
                  this.$set(identityArr, rIndex, {
                    label: rItem.label,
                    content: bool ? rItem.other : rItem.val
                  });
                });
                let key = item['val'],
                  content = {};
                content[key] = identityArr;
                arr.push({
                  bid: item.bid,
                  field_id: item.id,
                  content
                });
              } else {
                arr.push({
                  bid: item.bid,
                  field_id: item.id,
                  content: item.val
                });
              }
            } else if (item.type == 'checkbox') {
              // 判断复选框是否存在其他
              let bool = this.doSelected(item['val'], item.config.selected);
              if (bool) {
                let idx_ = item.val.indexOf(Object.keys(item.config.selected)[0]);
                item.val[idx_] = item.other;
                o = item.other;
              }
              arr.push({
                bid: item.bid,
                field_id: item.id,
                content: item.val
              });
            } else {
              arr.push({
                bid: item.bid,
                field_id: item.id,
                content: item.val || ''
              });
            }
          }

        });
        // 循环交换其他位置
        arr.forEach((i, d) => {
          //  && d==0 && i.content
          if (i.content instanceof Array && i.content.includes(o)) {
            let idx_ = i.content.indexOf(o);
            let arr_idx = i.content.length - 1;
            let a = i.content[idx_],
              b = i.content[arr_idx];
            if (arr_idx != idx_) {
              this.$set(i.content, idx_, b);
              this.$set(i.content, arr_idx, a);
            }

          }
        });
        setIUser({
          cid: this.$route.query.cid,
          field: JSON.stringify(arr)
        }).then((data) => {
          if (data.code == 10002) {
            this.$toast(data.data.msg);
            this.confirmShow = false;
            return;
          }
          this.confirmShow = false;
          this.$toast('提交成功！');
          this.$router.push({
            path: '/buy_success',
            query: {
              cid: this.cid
            }
          });
        });

      },
      /*
       *@param:
       *@return:
       *@Description: 验证数据是否为空
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-08 17:04:50
       */
      validationHandle(pullDataBool) {
        let bool = true;
        this.list.forEach((item, index) => {
          // 判断用是否提交过数据
          if (pullDataBool && this.userdetail && this.userdetail.length > 0) {
            // 遍历用户所提交的数据
            this.userdetail.forEach((userItem, userIndex) => {
              if (userItem.content && userItem.field_id == item.id) {
                // 判断是否是身份模块
                if (item.type == 'radio') {
                  if (item.config.condition == 'default') {
                    // 获取用户提交的身份
                    let key = Object.keys(userItem.content)[0];
                    this.identityVal = key;
                    // 获得当前身份 下的数据
                    let childArr = item.config.content_config[key];
                    item.val = key;
                    // 遍历当前身份下的模块并对应赋值
                    childArr.forEach((childItem, childIndex) => {
                      userItem.content[key].forEach((itm_, idx_) => {
                        if (childItem.label == itm_.label) {
                          let b = childItem.config.content && childItem.config.content.includes(itm_.content);
                          if (!b && childItem.config.selected) {
                            childItem.val = Object.keys(childItem.config.selected)[0];
                            childItem.other = itm_.content;
                          } else {
                            childItem.val = itm_.content;
                            childItem.other = '';
                          }
                        }
                      });

                    });
                  } else {
                    item.val = userItem.content;
                  }
                } else if (item.type == 'checkbox') {
                  userItem.content.forEach((uItm, uIdx) => {
                    let checkBool = item.config.content.includes(uItm);
                    item.val.push(checkBool ? uItm : Object.keys(item.config.selected)[0]);
                    item.other = checkBool ? '' : uItm;
                  });
                } else {
                  item.val = userItem.content;
                }
              }
            });
          }

          if (item.type != 'title') {
            // 是否有值为空或者val属性不存在
            if (!item['val']) {
              bool = false;
            }
            if (item.type == 'radio' && item.config.condition && item.config.condition == 'default' && item['val']) {
              item.config.content_config[item['val']].forEach((citem, cindex) => {
                if (!citem['val'] || (citem.config.selected && citem.config.selected[citem['val']] && !citem['other'])) {
                  if (citem.label != '我所在的公司名称') {
                    bool = false;
                  }
                }

              });
            }
            if (item.type == 'checkbox') {
              let val = item['val'];
              if (val.length == 0 || this.doSelected(val, item.config.selected) && !item['other']) {
                bool = false;
              }
            }
          }
        });
        this.saveBtn = bool;
      },
      // 判断数组内是否存在对象属性
      doSelected(arr, select) {
        let bool = false;
        arr.forEach((item, index) => {
          if (select && select[item]) {
            bool = true;
          }
        });
        return bool;
      },
      /*
       *@param: cid 从路由获取cid
       *@Description: 初始化请求接口
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-06 11:02:54
       */
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        this.cid = this.$route.query.cid;
        let arr = [geIUser({
          cid: this.cid
        }), getIProfession(), getIJob(), getIFunctions()];
        // 请求用户信息、所有行业信息、所有职级信息、所有职能信息、
        Promise.all(arr).then(data => {
          this.userdetail = data[0].userdetail;
          this.list = data[0].list;
          // 获取接口行业、职能、职级数据
          this.selectList["getprofession"] = data[1];
          this.selectList["getjob"] = data[2];
          this.selectList["getfunctions"] = data[3];


          this.list.forEach((item, index) => {
            // Json字符串转换为对象
            item.config = this.stringParseify(item.config);
            // 判断是否是复选框
            if (item.type == 'checkbox') {
              item['val'] = [];
            } else {
              item['val'] = '';
            }
            if (item.config.condition == 'rectangle') {
              item.val = '男';
            }
            // 获得身份信息
            if (item.config.condition == 'default') {
              // 获得身份信息对象
              this.identityObj = item.config.content_config;
              // 获得身份信息对象的所有key值config
              let identityArr = Object.keys(item.config.content_config);
              identityArr.forEach((itm, idx) => {
                // 循环身份信息内的数组，判断当前身份内array数组是否有值
                this.identityObj[itm].forEach((d, x) => {
                  if (d.config.content && d.config.content.length > 0) {
                    this.selectList[d.label] = d.config.content;
                  }
                });
              });
            }
          });
          this.bodyShow = true;
          this.validationHandle(true);
          this.$toast.clear();
        });
      }
    },
    created() {
      this.pullData();
      // 分享
      shareCon("course", this);
    }
};
</script>
<style lang="scss" scoped>
.infor-main {
  padding: 30px 30px 154px 30px;
  box-sizing: border-box;
  .submit-btn {
    color: #ffffff;
    font-size: 34px;
    border-radius: 33px;
    width: 174px;
    line-height: 66px;
    margin: 80px auto auto;
    text-align: center;
    display: block;
    background-color: #CCCCCC;
  }
  .submit-btn.on {
    background-color: #eb5032;
  }
  // 标题
  .title {
    margin-bottom: 60px;
    h3 {
      font-size: 32px;
      color: #eb5032;
      line-height: 42px;
    }
  }
  // 文本信息
  .text {
    display: flex;
    color: #333333;
    align-items: center;
    margin-bottom: 30px;
    label {
      display: block;
      width: 128px;
      text-align: right;
      font-size: 32px;
    }
    input {
      font-size: 26px;
      line-height: 70px;
      height: 70px;
      box-shadow: 0 0 2px #cccccc;
      border: none;
      border-radius: 8px;
      margin-left: 20px;
      flex: 1;
      padding: 22px 33px 22px 20px;
      outline: none;
      box-sizing: border-box;
    }
  }
  // select
  .select {
    display: flex;
    color: #333333;
    align-items: center;
    position: relative;
    margin-bottom: 30px;
    label {
      display: block;
      width: 128px;
      text-align: right;
      font-size: 32px;
    }
    .input {
      color: #999999;
      display: block;
      font-size: 26px;
      line-height: 70px;
      height: 70px;
      background-color: #ffffff;
      height: 70px;
      box-shadow: 0 0 2px #cccccc;
      border: none;
      border-radius: 8px;
      margin-left: 20px;
      flex: 1;
      padding: 0 33px 0 20px;
      outline: none;
      box-sizing: border-box;
    }
    .bottom {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 18px;
      img {
        width: 28px;
        height: 16px;
      }
    }
  }
  //  单选
  .radio {
    margin-bottom: 30px;
    .rectangle {
      display: flex;
      color: #333333;
      align-items: center;
      .label-title {
        display: block;
        width: 128px;
        text-align: right;
        font-size: 32px;
        margin-right: 20px;
      }
      .woman {
        margin-left: 34px;
      }
      .man,
      .woman {
        display: flex;
        color: #333333;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
          margin-right: 5px;
        }
        label {
          display: block;
          width: 120px;
          color: #ffffff;
          background-color: #cccccc;
          font-size: 32px;
          text-align: center;
          line-height: 70px;
          height: 70px;
          border-radius: 8px;
          input[type="radio"] {
            display: none;
            border: 0;
            outline: 0 !important;
            background-color: transparent;
            -webkit-appearance: none;
          }
        }
        label.on {
          background-color: #eb5032;
        }
      }
    }
    // 默认
    .default {
      .radio-identity {
        display: flex;
        color: #333333;
        align-items: center;
        .label-title {
          display: block;
          width: 128px;
          text-align: right;
          font-size: 32px;
          margin-right: 20px;
        }
        .identity {
          display: flex;
          color: #333333;
          align-items: center;
          font-size: 32px;
          &:nth-child(3) {
            margin-left: 44px;
          }
          label.icon {
            display: block;
            position: relative;
            width: 40px;
            height: 40px;
            border: 2px solid #cccccc;
            background-color: #ffffff;
            border-radius: 50%;
            margin-right: 20px;
            input[type="radio"] {
              display: none;
              border: 0;
              outline: 0 !important;
              background-color: transparent;
              -webkit-appearance: none;
            }
          }
          label.icon.on {
            background-color: #eb5032;
            &:after {
              display: block;
              content: "";
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 20px;
              height: 20px;
              background-color: #ffffff;
              border-radius: 50%;
            }
          }
        }
      }
      .textarea {
        padding-top: 30px;
        .label-title {
          display: block;
          text-align: left;
          font-size: 32px;
          margin-bottom: 14px;
        }
        textarea {
          width: 100%;
          resize: none;
          box-shadow: 0 0 2px #cccccc;
          border: none;
          border-radius: 8px;
          height: 144px;
          font-size: 26px;
          padding: 22px 20px;
          // line-height: 39px;
        }
      }
    }
  }
  // 复选框
  .checkbox {
    margin-top: 60px;
    color: #333333;
    .label-title {
      display: block;
      text-align: left;
      font-size: 32px;
      margin-bottom: 34px;
    }
    .familiarity {
      display: flex;
      color: #333333;
      flex-direction: column;
      font-size: 32px;
      .checkbox-group {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        line-height: 42px;
        &:last-child {
          margin-bottom: 0px;
        }
        label {
          line-height: 42px;
        }
        label.checkbox-text {
          font-size: 26px;
          flex: 1;
        }
        .other {
          width: 544px;
          padding: 0 20px;
          box-sizing: border-box;
          line-height: 70px;
          border-radius: 8px;
          border: 1px solid #cccccc;
        }
        label.icon {
          display: block;
          position: relative;
          width: 34px;
          height: 34px;
          border: 2px solid #cccccc;
          box-sizing: border-box;
          background-color: #ffffff;
          border-radius: 4px;
          margin-right: 25px;
          input[type="checkbox"] {
            display: none;
            border: 0;
            outline: 0 !important;
            background-color: transparent;
            -webkit-appearance: none;
          }
        }
        label.icon.on {
          background: url(../../../assets/press.png) center no-repeat;
          background-size: 100% 100%;
          border: none;
        }
      }
    }
    // 标签
    .tag-box {
      display: flex;
      color: #333333;
      flex-wrap: wrap;
      width: 100%;
      font-size: 32px;
      border-radius: 8px;
      border: 1px solid #cccccc;
      padding: 30px 20px;
      box-sizing: border-box;
      .checkbox-group {
        width: 50%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        line-height: 42px;
        label {
          line-height: 42px;
        }
        label.checkbox-text {
          font-size: 26px;
          flex: 1;
        }
        .other {
          width: 544px;
          line-height: 70px;
          border-radius: 8px;
          border: 1px solid #cccccc;
        }
        label.icon {
          display: block;
          position: relative;
          width: 34px;
          height: 34px;
          border: 2px solid #cccccc;
          box-sizing: border-box;
          background-color: #ffffff;
          border-radius: 4px;
          margin-right: 25px;
          input[type="checkbox"] {
            display: none;
            border: 0;
            outline: 0 !important;
            background-color: transparent;
            -webkit-appearance: none;
          }
        }
        label.icon.on {
          background: url(../../../assets/press.png) center no-repeat;
          background-size: 100% 100%;
          border: none;
        }
      }
    }
  }
  // 身份模块样式
  .tab-identity {
    margin-top: 30px;
  }
  .color3 {
    color: #333333 !important;
  }
  .style_tags_active {
    opacity: .6;
  }
}
</style>